<template>
  <div class="welcome-banner mb-4">
    <h1 class="display-5" v-if="member">
      欢迎您, {{ member.full_name }}
    </h1>
    <h1 class="display-5" v-else-if="isLoading">
      正在加载...
    </h1>
    <p class="fs-5 text-muted">
      欢迎回到广东省青年科技创新研究会会员系统。
    </p>
  </div>

  <div class="mb-4" id="activity-board">
    <el-card shadow="never" class="activity-card">
      <template #header>
        <div class="card-header">
          <h5 class="mb-0">活动与公告</h5>
        </div>
      </template>

      <el-skeleton :rows="5" animated v-if="isActivitiesLoading" />

      <div v-else-if="activities.length > 0">
        <el-space direction="vertical" alignment="stretch" class="w-100">

          <el-card
            v-for="activity in activities"
            :key="activity.id"
            shadow="hover"
            class="activity-item-card"
            @click="goToActivityDetail(activity.id)"
          >
            <el-row :gutter="20">
              <el-col :span="8" v-if="activity.image">
                <img :src="activity.image" class="activity-image" :alt="activity.title">
              </el-col>

              <el-col :span="activity.image ? 16 : 24">
                <h5 class="mb-1 fw-bold">{{ activity.title }}</h5>
                <small class="text-muted">
                  {{ new Date(activity.publish_date).toLocaleDateString() }}
                </small>
                <p class="mb-0 mt-2 card-text-content">
                  {{ activity.content.substring(0, 250) }}
                  <span v-if="activity.content.length > 250">...</span>
                </p>
              </el-col>
            </el-row>
          </el-card>
        </el-space>

        <div class="text-center mt-4" v-if="nextActivityPageUrl">
          <el-button
            type="primary"
            plain
            @click="loadMoreActivities"
            :loading="isMoreActivitiesLoading">
            {{ isMoreActivitiesLoading ? '正在加载...' : '加载更多活动' }}
          </el-button>
        </div>

      </div>

      <div v-else class="logo-placeholder">
        <el-image
          src="/logo.png"
          fit="contain"
          class="placeholder-logo-image"
        />
        <p class="text-muted mt-3">目前没有新的活动或公告。</p>
      </div>

    </el-card>
  </div>

  <el-row :gutter="20">

    <el-col :xs="24" :sm="12" :md="8">
      <el-card shadow="hover" class="h-100">
        <div class="card-content">
          <h5>个人中心</h5>
          <p>
            查看您的会员信息、积分状态、申请记录，并下载您的会员证书。
          </p>
          <el-button type="primary" @click="$router.push('/dashboard')">
            进入个人中心
          </el-button>
        </div>
      </el-card>
    </el-col>

    <el-col :xs="24" :sm="12" :md="8">
      <el-card shadow="hover" class="h-100">
        <div class="card-content">
          <h5>积分申请</h5>
          <p>
            提交新的积分申请，查看可申请的规则列表。
          </p>
          <el-button type="default" @click="$router.push('/apply')">
            前往申请
          </el-button>
        </div>
      </el-card>
    </el-col>

    <el-col :xs="24" :sm="12" :md="8" v-if="isStaff">
      <el-card shadow="hover" class="h-100 border-danger">
        <div class="card-content">
          <h5 class="text-danger">管理后台</h5>
          <p>
            (仅管理员可见) 审批会员提交的积分申请。
          </p>
          <el-button type="danger" @click="$router.push('/admin-dashboard')">
            进入管理后台
          </el-button>
        </div>
      </el-card>
    </el-col>

  </el-row>

</template>

<script>
//
// <script> 部分完全保持不变
//
import axios from 'axios';

export default {
  name: 'HomeView',
  data() {
    return {
      isLoading: true,
      member: null,
      isStaff: localStorage.getItem('isStaff') === 'true',
      isActivitiesLoading: true,
      activities: [],
      isMoreActivitiesLoading: false,
      nextActivityPageUrl: null,
    };
  },
  async mounted() {
    const token = localStorage.getItem('authToken');
    if (!token) {
      this.$router.push('/login');
      return;
    }

    // 1. 先获取会员信息
    try {
      const dashboardResponse = await axios.get('/members/api/dashboard/', {
        headers: { 'Authorization': `Token ${token}` }
      });

      if (dashboardResponse.data.member) {
         this.member = dashboardResponse.data.member;
         localStorage.setItem('isFeePaid', dashboardResponse.data.member.is_fee_paid ? 'true' : 'false');
         localStorage.setItem('isPremiumMember', dashboardResponse.data.member.is_premium_member ? 'true' : 'false');
      } else if (dashboardResponse.data.is_staff) {
         this.member = { full_name: '管理员' };
         localStorage.removeItem('isFeePaid');
         localStorage.removeItem('isPremiumMember');
      }
      this.isStaff = dashboardResponse.data.is_staff;
      localStorage.setItem('isStaff', this.isStaff ? 'true' : 'false');

    } catch (error) {
      console.error('获取主页数据失败:', error);
      localStorage.removeItem('authToken');
      localStorage.removeItem('isStaff');
      localStorage.removeItem('isFeePaid');
      localStorage.removeItem('isPremiumMember');
      this.$router.push('/login');
    } finally {
      this.isLoading = false;
    }

    // 2. 独立获取“活动”的第一页
    this.fetchInitialActivities(token);
  },

  methods: {
    // (获取活动的方法保持不变)
    async fetchInitialActivities(token) {
      this.isActivitiesLoading = true;
      try {
        const response = await axios.get('/members/api/activities/', {
          headers: { 'Authorization': `Token ${token}` }
        });
        this.activities = response.data.results;
        this.nextActivityPageUrl = response.data.next;
      } catch (error) {
        console.error('获取活动列表失败:', error);
      } finally {
        this.isActivitiesLoading = false;
      }
    },
    // (加载更多活动的方法保持不变)
    async loadMoreActivities() {
      if (!this.nextActivityPageUrl) return;
      this.isMoreActivitiesLoading = true;
      const token = localStorage.getItem('authToken');
      try {
        const response = await axios.get(this.nextActivityPageUrl, {
          headers: { 'Authorization': `Token ${token}` }
        });
        this.activities.push(...response.data.results);
        this.nextActivityPageUrl = response.data.next;
      } catch (error) {
        console.error('加载更多活动失败:', error);
      } finally {
        this.isMoreActivitiesLoading = false;
      }
    },
    // (跳转详情页的方法保持不变)
    goToActivityDetail(activityId) {
      this.$router.push({ name: 'ActivityDetail', params: { id: activityId } });
    },

    // (activated 和 watch 保持不变)
    activated() {
       this.isStaff = localStorage.getItem('isStaff') === 'true';
    },
    watch: {
      '$route'() {
         this.isStaff = localStorage.getItem('isStaff') === 'true';
      }
    }
  }
};
</script>

<style scoped>
/* --- V4.0 样式 --- */

/* 欢迎横幅 */
.welcome-banner .display-5 {
  font-weight: 600;
  color: var(--el-text-color-primary);
  font-size: 2.5rem; /* 缩小一点 */
}
.welcome-banner .fs-5 {
  font-size: 1.1rem !important;
}

/* 活动看板 */
.activity-card {
  border: none;
  background-color: transparent;
}
/* 移除 el-card 的默认 padding */
.activity-card :deep(.el-card__header) {
  padding: 0 0 1rem 0;
  border-bottom: 1px solid var(--el-border-color-light);
}
.activity-card :deep(.el-card__body) {
  padding: 1.5rem 0 0 0;
}
.activity-card .card-header h5 {
  font-weight: 600;
  font-size: 1.25rem;
}

/* 活动列表项 */
.activity-item-card {
  cursor: pointer;
  transition: transform 0.2s ease-out;
}
.activity-item-card:hover {
  transform: translateY(-5px);
}
.activity-image {
  width: 100%;
  height: 125px;
  object-fit: cover;
  border-radius: 4px;
}
.card-text-content {
  font-size: 0.9rem;
  color: var(--el-text-color-secondary);
  line-height: 1.6;
}

/* 【!! 关键修改：Logo 占位符样式 !!】 */
.logo-placeholder {
  text-align: center;
  padding: 3rem 0; /* 增加垂直内边距 */
  width: 100%;
}
.placeholder-logo-image {
  /* 【!! 您可以在这里随意缩放 !!】 */
  width: 200px;
  height: 200px;
  opacity: 0.5; /* 设为半透明，更有 "占位符" 的感觉 */
}


/* 底部导航卡片 */
.h-100 {
  height: 100%;
}
.card-content {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.card-content h5 {
  font-weight: 600;
}
.card-content p {
  font-size: 0.9rem;
  color: var(--el-text-color-regular);
  flex-grow: 1; /* 占据空间，把按钮推到底部 */
  min-height: 50px;
}
.border-danger {
  border-color: var(--el-color-danger-light-7);
}
.border-danger h5 {
  color: var(--el-color-danger);
}
</style>